import React from 'react'

interface ICardProps extends React.HTMLAttributes<HTMLDivElement> {
  dashed?: boolean
  block?: boolean
  skeleton?: boolean
}

const Card: React.FC<ICardProps> = ({
  children,
  dashed,
  block,
  skeleton,
  ...rest
}) => (
  <div
    className={`card ${dashed ? 'dashed' : ''} ${block ? 'block' : ''} ${
      skeleton ? 'skeleton' : ''
    }`}
    {...rest}
  >
    {children}
  </div>
)

export default Card
